import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { DETECTION_OPTIONS, createLanguageController } from "./language-policy";

// Language follows the company settings (language-policy.js): nothing is
// detected or cached at import; bootstrap applies the session user's or the
// host's policy before the first screen (language-session.js).
export const languageController = createLanguageController();

i18n
  .use(HttpBackend)
  .use(languageController.detector)
  .use(initReactI18next)
  .init({
    lng: languageController.initialLanguage(),

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.translation.json",
    },

    ns: [
      "common",
      "auth",
      "activity-log",
      "benchmark-dashboard",
      "bill-ocr",
      "call-for-help",
      "carbon-inventory",
      "company",
      "custom-framework",
      "dashboard",
      "data-entry",
      "esg",
      "esg-dashboard-v3",
      "g-element",
      "more-solutions",
      "notifications",
      "onboarding",
      "organization",
      "settings",
      "survey-management",
      "surveys",
      "target-setup",
      "userManagement",
    ],
    defaultNS: "common",
    fallbackNS: ["common", "auth"],

    supportedLngs: ["en", "ja", "zh-TW", "zh-CN", "it", "de", "th", "ko"],
    fallbackLng: "en",

    detection: { ...DETECTION_OPTIONS },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
      nsMode: "fallback",
    },
  });

languageController.attach(i18n);

export default i18n;
